import $ from 'jquery';
import {fullpage} from 'fullpage.js';
import velocity from 'velocity-animate';

export default class Fullpage {
  constructor() {
    this.APP = {}
    let ua = navigator.userAgent;
    this.APP.sp = ua.indexOf('iPhone') > -1 || ua.indexOf('iPod') > -1 || ua.indexOf('Android') > -1

    this.logoElm = document.getElementById('topLogo');
    this.sectionLeng = document.getElementsByClassName('section').length;
    this.header = document.getElementById('header');

    this.nav = document.getElementById('nav');
  }

  init() {
    if (!this.APP.sp) {
      // PCの場合の表示
      this.displayPC();
    } else {
      this.device = "sp";
      // SPの場合の表示
      // this.displaySP();

    }

    // 非表示コンテンツを非表示にする
  }

  displayPC() {
    let _this = this;
    $(document).ready( ()=> {

        $('#fullpage').fullpage({
          // アンカー設置
          menu: '#menu',
          anchors: ['topPage', 'firstPage', 'secondPage', 'thirdPage', 'forthPage', 'endPage'],
          autoScrolling: true,

          css3: true,
          scrollingSpeed: 800,
          fitToSection: true,
          fitToSectionDelay: 400,
          scrollBar: true,
          easing: 'easeInOutCubic',
          easingcss3: 'cubic-bezier( 0.455, 0.030, 0.515, 0.955 )',
          fadingEffect: true,
          controlArrows: true,
          verticalCentered: true,
          keyboardScrolling: false,
          recordHistory: false,
          // normalScrollElements: '.p-read',

          // 要素の高さが溢れた場合に、普通うのスクロール
          scrollOverflow: true,

          onLeave: (index, nextIndex, direction) => {
            // ロゴの表示/非表示の制御をする
            this.displayLogo(nextIndex);

            // _this.onLeave(index);
          },
          afterLoad: (anchorLink, index) => {
            this.displayMenu(index);

          }

        });
    });
  }
  displaySP() {
    let _this = this;
    // $(document).ready(function() {
    //
    //     $('#fullpage').fullpage({
    //       // アンカー設置
    //       menu: '#menu',
    //       anchors: ['firstPage', 'secondPage', '3rdPage', 'lastPage'],
    //       autoScrolling: false,
    //
    //       css3: true,
    //       scrollingSpeed: 800,
    //       fitToSection: true,
    //       fitToSectionDelay: 1000,
    //       scrollBar: true,
    //       easing: 'easeInOutCubic',
    //       easingcss3: 'cubic-bezier( 0.455, 0.030, 0.515, 0.955 )',
    //
    //       fadingEffect: true,
    //       controlArrows: true,
    //       verticalCentered: true,
    //
    //       // 要素の高さが溢れた場合に、普通うのスクロール
    //       scrollOverflow: true,
    //
    //       onLeave: function(index, nextIndex, direction){
    //         // _this.onLeave(index);
    //       },
    //       afterLoad: function(anchorLink, index){
    //         // _this.afterLoad(index);
    //
    //       }
    //
    //     });
    // });
  }

  onLeave(index, nextIndex, direction) {
    Velocity(document.querySelectorAll('.js-section-title')[index-1],
      {
        opacity: 0.0
      },
      {
        duration: 200
      }
    );
  }


  afterLoad(index) {
    Velocity(document.querySelectorAll('.js-section-title')[index-1],
      {
        opacity: 0.4
      },
      {
        duration: 200
      }
    );
  }

  displayLogo(nextIndex) {
    if (nextIndex !== 1) {
      // TOP以外なら
      Velocity(this.logoElm,
        {
          opacity: 1
        },
        {
          duration: 500,
          delay: 800

        }
      );
    } else {
      // TOPなら
      Velocity(this.logoElm,
        {
          opacity: 0
        },
        {
          duration: 300
        }
      );
    }
  }

  displayMenu(index) {
    if (index === this.sectionLeng) {
      // ENDページなら

      Velocity(this.logoElm,
        {
          translateY: "-70px"
        },
        {
          duration: 400
        }
      );

      Velocity(this.nav,
        {
          translateY: "60px"
        },
        {
          duration: 500,
          delay: 380

        }
      );


    } else {
      // ENDページ以外なら
      Velocity(this.logoElm,
        {
          translateY: "0px"
        },
        {
          duration: 500
        }
      );
      Velocity(this.nav,
        {
          translateY: "0px"
        },
        {
          duration: 500,
          delay: 380
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/components/Fullpage.js